import { useAgencyStore } from '@dashboard/stores/agencyStore'
import { useAuthStore } from '@dashboard/stores/authStore'
import { useSubscriptionStore } from '@dashboard/stores/subscriptionStore'

/**
 * Settings pages that only some accounts see. The settings nav hides them and
 * the route guard blocks their URLs with the same rule.
 *
 * - `perTeamBilling`: the open project is billed on its own (its owner is not on
 *   legacy account-wide billing).
 * - `legacyBilling`: the signed-in user pays for an account-wide legacy plan.
 * - `agency`: the signed-in user runs an agency.
 */
export type SettingsAccess = 'perTeamBilling' | 'legacyBilling' | 'agency'

export function useSettingsAccess() {
  const subscriptionStore = useSubscriptionStore()
  const authStore = useAuthStore()
  const agencyStore = useAgencyStore()

  const allows = (access: SettingsAccess | undefined): boolean => {
    switch (access) {
      case undefined:
        return true
      case 'perTeamBilling':
        return subscriptionStore.isPerTeamBilling
      case 'legacyBilling':
        return authStore.user?.billing_model === 'legacy'
      case 'agency':
        return agencyStore.isAgency
    }
  }

  return { allows }
}
